import { ActionTypesScreen3 } from "app/constants";

const defaultJobType = "All Jobs"
const defaultIndustry = "Manufacturing"

export const defaultState = {
  listData: [],
  objectData: {},
  singleData: null,
  jobTypeSelectedS3: defaultJobType,
  industryTypeSelectedS3: defaultIndustry
};

function Screen3Reducer(state = defaultState, action) {
    switch (action.type) {
        case ActionTypesScreen3.GET_INDSUTRY_DATA:
            return { ...state, industryData: action.payload }
        case ActionTypesScreen3.GET_AVERAGE_DATA_SCREEN3:
            return { ...state, averageDataScreen3: action.payload }
        case ActionTypesScreen3.GET_AGE_DATA:
            return { ...state, ageData: action.payload }
        case ActionTypesScreen3.GET_RACE_DATA:
            return { ...state, raceData: action.payload }
        case ActionTypesScreen3.GET_GENDER_DATA:
            return { ...state, genderData: action.payload }
        case ActionTypesScreen3.GET_REGIONAL_CONCENTRATION_DATA:
            return { ...state, regionalConcentrationData: action.payload }
        case ActionTypesScreen3.GET_REGIONAL_MIGRATION_DATA:
            return { ...state, regionalMigrationData: action.payload }
        case ActionTypesScreen3.SET_SELECTED_JOB_TYPE_S3:
            return { ...state, jobTypeSelectedS3: action.payload }
        case ActionTypesScreen3.SET_SELECTED_INDUSTRY_TYPE_S3:
            return { ...state, industryTypeSelectedS3: action.payload }
        default:
            return state;
    }
  }
  
  export default Screen3Reducer;